'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'star-half';
var width = 576;
var height = 512;
var aliases = [61731];
var unicode = 'f089';
var svgPathData = ['M29.4 171.9c-.9 2.9-.2 6 1.9 8.1L145.7 294.6c3.6 3.6 5.3 8.7 4.5 13.8L125 468.3c-.5 3 .8 6 3.2 7.7s5.6 2 8.3 .7l147.2-74.9c2.7-1.4 4.4-4.1 4.4-7.1l0-408.2c0-.6-.1-1.2-.2-1.7-.1-.4-.2-.6-.3-.8-2.8 .2-5.3 1.8-6.6 4.3L207.4 132.6c-2.3 4.6-6.7 7.7-11.7 8.5L35.7 166.5c-3 .5-5.4 2.6-6.4 5.4z', 'M287.5-16c-2.8 .2-5.3 1.8-6.6 4.3L207.4 132.6c-2.3 4.6-6.7 7.7-11.7 8.5L35.7 166.5c-3 .5-5.4 2.6-6.4 5.4s-.2 6 1.9 8.1L145.7 294.6c3.6 3.6 5.3 8.7 4.5 13.8L125 468.3c-.5 3 .8 6 3.2 7.7l0 0c2.4 1.8 5.6 2 8.3 .7l147.2-74.9c2.7-1.4 4.4-4.1 4.4-7.1l0-408.2c0-.6-.1-1.2-.2-1.7-.1-.4-.2-.6-.3-.8zm-20.8-2.9c4.1-8 12.4-13.1 21.4-13.1 5.7 0 10 3.1 12.5 6.8 2.4 3.5 3.4 7.8 3.4 11.7l0 408.2c0 9-5.1 17.3-13.1 21.4L143.8 491c-8 4.1-17.7 3.3-25-2l0 0c-7.3-5.3-11-14.2-9.6-23.2L134.4 305.9 20 191.4c-6.4-6.4-8.6-15.8-5.8-24.4s10.1-14.9 19.1-16.3l159.9-25.4 73.6-144.2z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarHalf = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;